<template>
  <div>
    <div>
      <b-tabs content-class="mt-3">
        <b-tab title="Customer" active>
          <td>
            <b-input-group style="margin-left: 10px; margin-bottom: 10px">
              <b-form-input v-model="custfilter" placeholder="Search.." />
              <b-input-group-append>
                <b-button :disabled="!custfilter" @click="custfilter = ''"
                  >Clear</b-button
                >
              </b-input-group-append>
            </b-input-group>
          </td>
          <br />
          <b-card header="Inactive Customer List">
            <b-table
              show-empty
              bordered
              responsive="sm"
              class="mb-0 table-outline"
              hover
              small
              autocomplete="off"
              striped
              fixed
              head-variant="light"
              :busy.sync="isBusy"
              :items="customerlist"
              :fields="custfields"
              :filter="custfilter"
              :per-page="perPage"
              :current-page="currentPage"
            >
              <template v-slot:cell(Action)="data">
                <router-link
                  tag="button"
                  :to="'/Maintenance/636977056989346870/modify/' + data.item.id"
                  class="btn btn-primary btn-sm"
                >
                  <i class="fa fa-pencil-square-o"></i> </router-link
                >&nbsp;
                <!-- <b-button size="sm" variant="danger" class="btn btn-danger btn-sm"
                  @click="onSelecteItemToDelete(data.item)">
                  <i class="fa fa-trash-o"></i>
                </b-button> -->
              </template>
              <template v-slot:cell(isactive)="data">
                <i
                  :class="
                    data.item.isactive == 1
                      ? 'activeStatus icon-check active_icon'
                      : 'inactiveStatus icon-close inactive_icon'
                  "
                ></i>
              </template>
            </b-table>
          </b-card>
          <div style="margin-top: 5px">
            <b-pagination
              v-model="currentPage"
              :total-rows="custrows"
              :per-page="perPage"
              aria-controls="my-table"
            >
            </b-pagination>
          </div>
        </b-tab>
        <b-tab title="Lane Master">
          <td>
            <b-input-group style="margin-left: 10px; margin-bottom: 10px">
              <b-form-input v-model="lanefilter" placeholder="Search.." />
              <b-input-group-append>
                <b-button :disabled="!lanefilter" @click="lanefilter = ''"
                  >Clear</b-button
                >
              </b-input-group-append>
            </b-input-group>
          </td>
          <br />
          <b-card header="Inactive Lane List">
            <b-table
              show-empty
              bordered
              responsive="sm"
              class="mb-0 table-outline"
              hover
              small
              autocomplete="off"
              striped
              fixed
              head-variant="light"
              :busy.sync="isBusy"
              :items="lanelist"
              :fields="lanefields"
              :filter="lanefilter"
              :per-page="perPage"
              :current-page="currentPage"
            >
              <template v-slot:cell(Action)="data">
                <router-link
                  tag="button"
                  :to="
                    '/Maintenance/636917878380103450/modify/lane-master/' +
                    data.item.id
                  "
                  class="btn btn-primary btn-sm"
                >
                  <i class="fa fa-pencil-square-o"></i> </router-link
                >&nbsp;
                <!-- <b-button size="sm" variant="danger" class="btn btn-danger btn-sm"
                  @click="onSelecteItemToDelete(data.item)">
                  <i class="fa fa-trash-o"></i>
                </b-button> -->
              </template>
              <template v-slot:cell(checklistdescription)="data">
                <div class="ellipsis">
                  <span>{{ data.item.checklistdescription }}</span>
                </div>
              </template>
              <template v-slot:cell(description)="data">
                <div class="ellipsis">
                  <span>{{ data.item.description }}</span>
                </div>
              </template>
              <template v-slot:cell(status)="data">
                <i
                  :class="
                    data.item.status == 1
                      ? 'activeStatus icon-check active_icon'
                      : 'inactiveStatus icon-close inactive_icon'
                  "
                ></i>
              </template>
              <template v-slot:cell(isoccupied)="data">
                <span>{{ data.item.isoccupied == 1 ? "YES" : "NO" }}</span>
              </template>
            </b-table>
          </b-card>
          <div style="margin-top: 5px">
            <b-pagination
              v-model="currentPage"
              :total-rows="lanerows"
              :per-page="perPage"
              aria-controls="my-table"
            >
            </b-pagination>
          </div>
        </b-tab>
        <b-tab title="Trucker">
          <td>
            <b-input-group style="margin-left: 10px; margin-bottom: 10px">
              <b-form-input v-model="truckerfilter" placeholder="Search.." />
              <b-input-group-append>
                <b-button :disabled="!truckerfilter" @click="truckerfilter = ''"
                  >Clear</b-button
                >
              </b-input-group-append>
            </b-input-group>
          </td>
          <br />
          <b-card header="Inactive Trucker List">
            <b-table
              show-empty
              bordered
              responsive="sm"
              class="mb-0 table-outline"
              hover
              small
              autocomplete="off"
              striped
              fixed
              head-variant="light"
              :busy.sync="isBusy"
              :items="trucklist"
              :fields="truckfields"
              :filter="truckerfilter"
              :per-page="perPage"
              :current-page="currentPage"
            >
              <template v-slot:cell(Action)="data">
                <b-button
                  @click="editTrucker(data.item.fleetownerId)"
                  class="btn btn-info btn-sm"
                >
                  <i class="fa fa-pencil-square-o"></i> </b-button
                >&nbsp;
                <!-- <b-button size="sm" variant="danger" class="btn btn-danger btn-sm"
                  @click="onSelecteItemToDelete(data.item)">
                  <i class="fa fa-trash-o"></i>
                </b-button> -->
              </template>
              <template v-slot:cell(status)="data">
                <i
                  :class="
                    data.item.status == 'A'
                      ? 'activeStatus icon-check active_icon'
                      : 'inactiveStatus icon-close inactive_icon'
                  "
                ></i>
              </template>
            </b-table>
          </b-card>
          <div style="margin-top: 5px">
            <b-pagination
              v-model="currentPage"
              :total-rows="truckerrows"
              :per-page="perPage"
              aria-controls="my-table"
            >
            </b-pagination>
          </div>
        </b-tab>
        <b-tab title="Driver">
          <td>
            <b-input-group style="margin-left: 10px; margin-bottom: 10px">
              <b-form-input v-model="driverfilter" placeholder="Search.." />
              <b-input-group-append>
                <b-button :disabled="!driverfilter" @click="driverfilter = ''"
                  >Clear</b-button
                >
              </b-input-group-append>
            </b-input-group>
          </td>
          <br />
          <b-card header="Inactive Driver List">
            <b-table
              show-empty
              bordered
              responsive="sm"
              class="mb-0 table-outline"
              hover
              small
              autocomplete="off"
              striped
              fixed
              head-variant="light"
              :busy.sync="isBusy"
              :items="driverlist"
              :fields="driverfields"
              :filter="driverfilter"
              :per-page="perPage"
              :current-page="currentPage"
            >
              <template v-slot:cell(Action)="data">
                <b-button
                  size="sm"
                  variant="info"
                  class="btn btn-info btn-sm"
                  @click="editdriver(data.item)"
                >
                  <i class="fa fa-pencil-square-o"></i> </b-button
                >&nbsp;
                <!-- <b-button
                  size="sm"
                  variant="danger"
                  class="btn btn-danger btn-sm"
                  @click="onSelecteItemToDelete(data.item)"
                >
                  <i class="fa fa-trash-o"></i>
                </b-button> -->
              </template>
              <template v-slot:cell(fullname)="data">
                {{ data.item.firstname }} {{ data.item.lastname }}
              </template>
              <template v-slot:cell(status)="data">
                <i
                  :class="
                    data.item.status == 'A'
                      ? 'activeStatus icon-check active_icon'
                      : 'inactiveStatus icon-close inactive_icon'
                  "
                ></i>
              </template>
            </b-table>
          </b-card>
          <div style="margin-top: 5px">
            <b-pagination
              v-model="currentPage"
              :total-rows="driverrows"
              :per-page="perPage"
              aria-controls="my-table"
            >
            </b-pagination>
          </div>
        </b-tab>
        <b-tab title="Vehicle">
          <td>
            <b-input-group style="margin-left: 10px; margin-bottom: 10px">
              <b-form-input v-model="vehiclefilter" placeholder="Search.." />
              <b-input-group-append>
                <b-button :disabled="!vehiclefilter" @click="vehiclefilter = ''"
                  >Clear</b-button
                >
              </b-input-group-append>
            </b-input-group>
          </td>
          <br />
          <b-card header="Inactive Vehicle List">
            <b-table
              show-empty
              bordered
              responsive="sm"
              class="mb-0 table-outline"
              hover
              small
              autocomplete="off"
              striped
              fixed
              head-variant="light"
              :busy.sync="isBusy"
              :items="vehiclelist"
              :fields="vehiclefields"
              :filter="vehiclefilter"
              :per-page="perPage"
              :current-page="currentPage"
            >
              <template v-slot:cell(Action)="data">
                <router-link
                  tag="button"
                  :to="
                    '/Maintenance/2017041905420722/modify/vehicles/' +
                    data.item.plateno
                  "
                  class="btn btn-primary btn-sm"
                >
                  <i class="fa fa-pencil-square-o"></i> </router-link
                >&nbsp;
                <!-- <b-button
                  size="sm"
                  variant="danger"
                  class="btn btn-danger btn-sm"
                  @click="onSelecteItemToDelete(data.item)"
                >
                  <i class="fa fa-trash-o"></i>
                </b-button> -->
              </template>

              <template v-slot:cell(status)="data">
                <i
                  :class="
                    data.item.status == 'A'
                      ? 'activeStatus icon-check active_icon'
                      : 'inactiveStatus icon-close inactive_icon'
                  "
                ></i>
              </template>
            </b-table>
          </b-card>
          <div style="margin-top: 5px">
            <b-pagination
              v-model="currentPage"
              :total-rows="vehiclerows"
              :per-page="perPage"
              aria-controls="my-table"
            >
            </b-pagination>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      perPage: this.$store.getters.perPage,
      totalItem: 0,
      currentPage: 1,
      custfilter: null,
      lanefilter: null,
      truckerfilter: null,
      driverfilter: null,
      vehiclefilter: null,
      driver: null,
      isBusy: false,

      customerlist: null,
      custfields: [
        {
          key: "Action",
        },
        {
          key: "custcode",
          label: "Customer Code",
          sortable: true,
        },
        {
          key: "custname",
          label: "Customer Name",
          sortable: true,
        },
        {
          key: "address",
          label: "Address",
          sortable: true,
        },
        {
          key: "contact",
          label: "Contact No.",
          sortable: true,
        },
        {
          key: "shiptocode",
          label: "Shipcode",
          sortable: true,
        },
        {
          key: "shiptoaddress",
          label: "Ship address",
        },
        {
          key: "isactive",
          label: "Active",
          sortable: true,
        },
      ],

      lanelist: null,
      lanefields: [
        {
          key: "Action",
        },
        {
          key: "id",
          label: "ID",
          sortable: true,
        },
        {
          key: "laneno",
          label: "Lane Number",
          sortable: true,
        },
        {
          key: "lanedisplay",
          label: "Lane Description",
          sortable: true,
        },
        {
          key: "occupant",
          label: "Occupant",
          sortable: true,
        },

        {
          key: "transtype",
          label: "Trantype",
          sortable: true,
        },
        {
          key: "isoccupied",
          label: "Occupied",
        },

        {
          key: "status",
          label: "Status",
          sortable: true,
        },
      ],

      trucklist: null,
      truckfields: [
        {
          key: "Action",
        },
        {
          key: "fleetownerId",
          label: "Trucker ID",
          sortable: true,
        },
        {
          key: "ownername",
          label: "Owner Name",
          sortable: true,
        },
        {
          key: "contactperson",
          label: "Contact Person",
          sortable: true,
        },
        {
          key: "telephoneno",
          label: "Tel",
        },
        {
          key: "celphoneno",
          label: "Mobile",
        },
        {
          key: "emailadd",
          label: "Email",
        },
        {
          key: "address",
          label: "Address",
          sortable: true,
        },
        {
          key: "remarks",
          label: "Remark",
          sortable: true,
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
        },
      ],

      driverlist: null,
      driverfields: [
        {
          key: "Action",
        },
        {
          key: "licenseno",
          label: "License No",
          sortable: true,
        },
        {
          key: "ownername",
          label: "Trucker",
          sortable: true,
        },
        {
          key: "fullname",
          label: "Full Name",
          sortable: true,
        },
        {
          key: "emailadd",
          label: "Email Address",
          sortable: true,
        },
        {
          key: "contactno",
          label: "Mobile",
        },
        {
          key: "ownername",
          label: "Owner Name",
          sortable: true,
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
        },
      ],

      vehiclelist: null,
      vehiclefields: [
        {
          key: "Action",
        },
        {
          key: "plateno",
          label: "Plate Number",
          sortable: true,
        },
        {
          key: "ownername",
          label: "Trucker",
          sortable: true,
        },
        {
          key: "vehicletype",
          label: "Vehicletype",
        },
        {
          key: "description",
          label: "Description",
          sortable: true,
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
        },
      ],
    };
  },

  computed: {
    custfilter() {
      this.currentPage = 1;
      this.totalrows = this.customerlist.length;
    },

    custrows() {
      return this.customerlist.length;
    },

    lanefilter() {
      this.currentPage = 1;
      this.totalrows = this.lanelist.length;
    },

    lanerows() {
      return this.lanelist.length;
    },

    truckerfilter() {
      this.currentPage = 1;
      this.totalrows = this.trucklist.length;
    },

    truckerrows() {
      return this.trucklist.length;
    },

    driverfilter() {
      this.currentPage = 1;
      this.totalrows = this.driverlist.length;
    },

    driverrows() {
      return this.driverlist.length;
    },

    vehiclefilter() {
      this.currentPage = 1;
      this.totalrows = this.vehiclelist.length;
    },

    vehiclerows() {
      return this.vehiclelist.length;
    },
  },

  created() {
    this.getcustomer();
    this.getlane();
    this.gettrucker();
    this.getdriver();
    this.getvehicle();
  },

  methods: {
    getcustomer() {
      this.$store.commit("setLoading", true);

      axios
        .get(
          this.$store.state.IFMSURLlocal +
            "get-customer-inactive?brancode=" +
            this.$store.state.selectedWarehouse
        )
        .then((resp) => {
          this.customerlist = resp.data;
          console.log(resp.data);
          this.$store.commit("setLoading", false);
        });
    },

    getlane() {
      this.$store.commit("setLoading", true);
      axios
        .get(
          this.$store.state.IFMSURLlocal +
            "get-lane-list-inactive?brancode=" +
            this.$store.state.selectedWarehouse
        )
        .then((resp) => {
          this.lanelist = resp.data;
          console.log(resp.data);
          this.$store.commit("setLoading", false);
        });
    },

    gettrucker() {
      axios
        .get(
          this.$store.state.IFMSURLlocal +
            "get-fleet-owner-list-inactive?brancode=" +
            this.$store.state.selectedWarehouse
        )
        .then((resp) => {
          this.trucklist = resp.data;
          console.log(resp.data);
          this.$store.commit("setLoading", false);
        });
    },

    getdriver() {
      axios
        .get(
          this.$store.state.IFMSURLlocal +
            "get-driver-inactive?brancode=" +
            this.$store.state.selectedWarehouse
        )
        .then((resp) => {
          this.driverlist = resp.data;
        });
    },

    getvehicle() {
      axios
        .get(
          this.$store.state.IFMSURLlocal +
            "get-fleet-inactive?brancode=" +
            this.$store.state.selectedWarehouse
        )
        .then((resp) => {
          this.vehiclelist = resp.data;
        });
    },

    editTrucker(id) {
      this.$store.state.fleetId = id;
      this.$router.push(
        "/Maintenance/2017041901085014/modify/fleetowner/" + id
      );
    },

    editdriver(item) {
      this.$store.state.driver = item;
      this.$router.push(
        "/Maintenance/2017041905404978/modify/driver/" + item.licenseno
      );
    },
  },
};
</script>